import { CACHE_VERSION } from '@/utils/configs/public.config';
import Cache from '@/utils/libs/Cache';

class _InstaStorage extends Cache {
  constructor() {
    super();
    this.nameSpace = `${CACHE_VERSION}_Insta`;
  }

  set(key, value) {
    let obj = this.get();
    obj[key] = value;
    obj = JSON.stringify(obj);
    window.localStorage.setItem(this.nameSpace, obj);
  }

  get(key, options = {}) {
    let value = window.localStorage.getItem(this.nameSpace);
    if (value) {
      value = JSON.parse(value);
    } else {
      value = {};
    }

    if (!key) {
      return value;
    } else {
      if (options.type === 'object') {
        return value[key] ?? {};
      }
      return value[key];
    }
  }

  remove(key) {
    let obj = this.get();
    delete obj[key];
    obj = JSON.stringify(obj);
    window.localStorage.setItem(this.nameSpace, obj);
  }

  clear() {
    window.localStorage.removeItem(this.nameSpace);
  }
}

const InstaStorage = new _InstaStorage();
export default InstaStorage;
